// Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import backgroundImage from './background.jpg';
import iconOne from './assets/Icons/idea.png';
import iconTwo from './assets/Icons/growth.png';
import iconThree from './assets/Icons/team.png';
import './Consultbutton.css'; // <-- Import the CSS file
import './Home.css';  // Add mobile-first styles
import './dashbutton.css'; // use dashbutton styling for CTA
import { useDeviceDetection } from './hooks/useDeviceDetection';



function Home() {
  const { deviceType, isMobile } = useDeviceDetection();

  // Mobile View - Centered design matching screenshot
  if (isMobile) {
    const mobileHeroStyle = {
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden',
      overscrollBehavior: 'none'
    };

    const mobileTitleStyle = {
      color: '#fff',
      fontSize: '2.5rem',
      fontWeight: 'bold',
      lineHeight: '1.2',
      marginBottom: '2rem',
      textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
      maxWidth: '90%'
    };

    const mobileBoxesStyle = {
      backgroundColor: '#1a1a2e',
      padding: '3rem 1rem',
      paddingBottom: 'calc(3rem + env(safe-area-inset-bottom, 100px))',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      alignItems: 'center'
    };

    const mobileBoxStyle = {
      width: '90%',
      maxWidth: '320px',
      padding: '2rem 1.5rem',
      borderRadius: '12px',
      textAlign: 'center',
      color: '#fff',
      boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
    };

    const mobileIconStyle = {
      width: '60px',
      height: '60px',
      marginBottom: '1rem',
      filter: 'brightness(0) invert(1)'
    };

    return (
      <div style={{ 
        minHeight: '100vh', 
        overscrollBehavior: 'none',
        paddingBottom: 'calc(2rem + env(safe-area-inset-bottom, 100px))'
      }}>
        {/** 1) HERO SECTION */}
        <div style={mobileHeroStyle}>
          <h1 style={mobileTitleStyle}>
            Confidence in the classroom<br />
            starts with the right tutor.
          </h1>
          <Link to="/form" style={{ textDecoration: 'none' }}>
            <button className="dashbutton" style={{ 
              fontSize: '1.2rem', 
              padding: '1rem 2rem', 
              width: 'auto',
              height: 'auto',
              minWidth: '200px'
            }}> Book a Consultation </button>
          </Link>
        </div>

        {/** 2) THREE COLORED BOXES */}
        <div style={mobileBoxesStyle}>
          {/* Box 1 */}
          <div style={{ 
            ...mobileBoxStyle, 
            backgroundColor: '#D97D0D' 
          }}>
            <img src={iconTwo} style={mobileIconStyle} alt="Icon Two" />
            <h3 style={{ fontSize: '1.4rem', marginBottom: '0.5rem' }}>Job Opportunities</h3>
            <p style={{ fontSize: '1rem', opacity: '0.9', margin: 0 }}>For University Students</p>
          </div>

          {/* Box 2 */}
          <div style={{ 
            ...mobileBoxStyle, 
            backgroundColor: '#6633CC' 
          }}>
            <img src={iconOne} style={mobileIconStyle} alt="Icon One" />
            <h3 style={{ fontSize: '1.4rem', marginBottom: '0.5rem' }}>Affordable Expert Tutors</h3>
            <p style={{ fontSize: '1rem', opacity: '0.9', margin: 0 }}>For high-school and middle-school students</p>
          </div>

          {/* Box 3 */}
          <div style={{ 
            ...mobileBoxStyle, 
            backgroundColor: '#2A7F31' 
          }}>
            <img src={iconThree} style={mobileIconStyle} alt="Icon Three" />
            <h3 style={{ fontSize: '1.4rem', marginBottom: '0.5rem' }}>Child Development</h3>
            <p style={{ fontSize: '1rem', opacity: '0.9', margin: 0 }}>through student-mentor learning</p>
          </div>
        </div>
      </div>
    );
  }

  // Desktop View (current desktop design)
  // Container uses flex to position children at the top-left
  const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    overflow: 'auto',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',    // stack items (text, button) vertically
    alignItems: 'flex-start',   // align them to the left
    justifyContent: 'flex-start', 
    padding: '50px 60px',       // spacing from the edges
  };

  // Text is left-aligned by default in a flex column
  const textStyle = {
    color: '#fff',
    fontSize: '6rem',
    fontWeight: 'bold',
    lineHeight: '1.2',
    marginBottom: '2rem',  // give space between text and button
    // No position: 'relative', no top/left
  };

  
  const boxesContainerStyle = {
    marginTop: '-100px',
    display: 'flex',
    justifyContent: 'center',  // centers the boxes horizontally
    alignItems: 'flex-start',
    gap: '2rem',               // space between boxes
    padding: '2rem 2rem',      // space around the box section
    flexWrap: 'wrap',          // Allow boxes to wrap
  };

  const boxStyle = {
    flex: '1',                 // each box can grow/shrink equally
    minWidth: '150px',         // set a minimum width so they don't get too skinny
    backgroundColor: '#eee',   // default color (you'll override for each box)
    color: '#fff',
    padding: '3rem',           // space inside the box
    textAlign: 'center',
    borderRadius: '1px',
  };
    // Icon style
    const iconStyle = {
      width: '60px',
      height: '60px',
      marginBottom: '1rem',
    };
  

  return (
    <div>
      {/** 1) HERO SECTION */}
      <div style={containerStyle}>
        <div style={textStyle}>
          Confidence in the classroom <br />
          starts with the right tutor.
        </div>
        <Link to="/form" style={{ textDecoration: 'none' }}>
        <button className="consultbutton"> Book a Consultation </button>
        </Link>
      </div>

      {/** 2) THREE COLORED BOXES */}
      <div style={boxesContainerStyle}>

        {/* Box 1 */}
        <div style={{ 
          ...boxStyle, 
          backgroundColor: '#D97D0D' // orange
        }}>
       <img src={iconTwo} style={iconStyle} alt="Icon Two" />
          <h3>Job Opportunities</h3>
          <h3>For University Students</h3>
        </div>

        {/* Box 2 */}
        <div style={{ 
          ...boxStyle, 
          backgroundColor: '#6633CC' // purple
        }}>
       <img src={iconOne} style={iconStyle} alt="Icon One" />

          <h3>Affordable Expert Tutors</h3>
          <h3>For high-school and middle-school students</h3>
        </div>

        {/* Box 3 */}
        <div style={{
          ...boxStyle,
          backgroundColor: '#2A7F31' // green
        }}>
       <img src={iconThree} style={iconStyle} alt="Icon Three" />
          <h3>Child Development</h3>
          <h3>through student-mentor learning</h3>
        </div>
      </div>
    </div>
  );
}

export default Home;